import { render } from "./GenericPager.vue?vue&type=template&id=7c2e00b2"
import script from "./GenericPager.vue?vue&type=script&lang=js"
export * from "./GenericPager.vue?vue&type=script&lang=js"

import "./GenericPager.vue?vue&type=style&index=0&id=7c2e00b2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__